import React from 'react';

interface Props {
    nowPage: number;
    prevBlockNum: number;
    startBlock: number;
    endBlock: number;
    totPageSize: number;
    currentBlock: number;
    totBlock: number;
    nextBlockNum: number;
    handlePage: (pageNum: number) => void;
}

const Paging: React.FC<Props> = ({
    nowPage,
    prevBlockNum,
    startBlock,
    endBlock,
    totBlock,
    totPageSize,
    currentBlock,
    nextBlockNum,
    handlePage,
}) => {

    const prevMore = () => {
        if (nowPage > 5) {
            return (<a href='#' onClick={() => handlePage(prevBlockNum)} className='prevmore'><span className='visible'>처음</span></a>);
        } else if (nowPage < 6) {
            return (<a href="#" onClick={() => handlePage(1)} className="prevmore"><span className="visible">처음</span></a>);
        }
    }

    const prev = () => {
        if (nowPage > 1) {
            return (<a href='#' onClick={() => handlePage(nowPage - 1)} className='prev'><span className='visible'>이전</span></a>);
        } else if (nowPage === 1) {
            return (<a href="#" className="prev"><span className="visible">이전</span></a>);
        }
    }

    const next = () => {
        if (nowPage < totPageSize) {
            return (<a href="#" onClick={() => handlePage(nowPage + 1)} className="next"><span className="visible">다음</span></a>)
        } else if (nowPage === totPageSize) {
            return (<a href="#" onClick={() => handlePage(0)} className="next"><span className="visible">다음</span></a>)
        }
    }

    const last = () => {
        if (currentBlock <= totBlock) {
            if (currentBlock === totBlock) {
                if (endBlock === nowPage) {
                    return (<a href="#" onClick={() => handlePage(0)} className="nextmore"><span className="visible">마지막</span></a>)
                } else {
                    return (<a href="#" onClick={() => handlePage(endBlock)} className="nextmore"><span className="visible">마지막</span></a>)
                }
            } else {
                return (<a href="#" onClick={() => handlePage(nextBlockNum)} className="nextmore"><span className="visible">마지막</span></a>)
            }
        }
    }

    const pageNumbers = [];

    for (let i = startBlock; i <= endBlock; i ++) {
        pageNumbers.push(i);
    }

    return (
        <div className='paging'>
            {
                prevMore()
            }
            {
                prev()
            }
            {
                pageNumbers.map((number) => (
                    <a key={number} href="#" className={number === nowPage? 'active': ''} onClick={()=> handlePage(number)}>{number}</a>
                ))
            }
            {
                next()
            }
            {
                last()
            }
        </div>
    )
}

export default Paging;